import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { TextareaAutosize } from "@material-ui/core";
import emailjs from "emailjs-com";
// const classnames = require("classnames");

const useStyles = (theme) => ({
	root: {
		margin: "auto",
		display: "grid",
		templateGridColumns: "1fr 1fr 1fr 1fr",
		gridGap: "20px",

		width: "50%",

		"& .MuiFilledInput-root": {
			background: "rgb(232, 241, 250)",
		},
	},
	buttonStyle: {
		"& .MuiFilledInput-root": {
			background: "#666",
			color: "#fff",
			align: "center ",
			borderRadius: "10px",
			"& :hover": {
				background: "#777",
				color: "#fff",
				borderRadius: "10px",
				display: "inline",
				border: "none",
			},
		},
	},
	messageStyling: {
		background: "#eaeaea",
		border: "none",
		borderRadius: "10px",
		outline: "none",
		padding: "10px",
	},
	validationError: {},
});

class ContactMe extends Component {
	state = {
		name: "",
		email: "",
		message: "",
		error: "",
		succuss: "",
	};

	messageValidation = (name, message) => {
		if (message.length === 0 || name.length <= 3) {
			return false;
		}
		return true;
	};
	emailValidation = (email) => {
		const re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};
	validateEmail = () => {
		return new Promise((result, errorCallback) => {
			if (
				this.emailValidation(this.state.email) &&
				this.messageValidation(this.state.name, this.state.message)
			) {
				result({
					name: this.state.name,
					email: this.state.email,
					message: this.state.message,
				});
			} else {
				errorCallback({
					errorMessage: "invalid inputs",
				});
			}
		});
	};

	onChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	onSubmit = (e) => {
		e.preventDefault();

		this.validateEmail()
			.then((data) => {
				emailjs
					.send(
						"service_desu_123",
						"template_iuxmg7a",
						data,
						"user_osUzXxpEjdGMwOCWBiX01"
					)
					.then(
						(succuss) => {
							this.setState({
								succuss: "I will respond back soon!",
							});
						},
						(error) => {
							alert(error.text);
						}
					);

				this.setState({
					name: "",
					email: "",
					message: "",
					error: "",
					succuss: "",
				});
			})
			.catch((err) =>
				this.setState({
					error: err.errorMessage,
					succuss: "",
				})
			);
	};

	render() {
		const { classes } = this.props;
		return (
			<form
				className={classes.root}
				noValidate
				autoComplete="off"
				onSubmit={this.onSubmit}>
				<div>
					<span style={{ color: "green" }}>{this.state.succuss}</span>
				</div>
				<TextField
					id="filled-basic"
					label="name"
					variant="filled"
					name="name"
					value={this.state.name}
					onChange={this.onChange}
					className={classes.validationError}
				/>
				<TextField
					id="filled-basic"
					label="email"
					variant="filled"
					name="email"
					value={this.state.email}
					onChange={this.onChange}
				/>
				<TextareaAutosize
					id="filled-basic"
					placeholder="message"
					variant="filled"
					name="message"
					minRows={10}
					maxRows={10}
					value={this.state.message}
					onChange={this.onChange}
					className={classes.messageStyling}
				/>
				<TextField
					id="filled-basic"
					variant="filled"
					type="submit"
					value="Submit"
					color="primary"
					onSubmit={this.onSubmit}
					className={classes.buttonStyle}
				/>
				<div>
					<span style={{ color: "red" }}>{this.state.error}</span>
				</div>
			</form>
		);
	}
}

export default withStyles(useStyles, { withTheme: true })(ContactMe);
